import { OnboardingStep } from 'api/model'
import { useEffect } from 'react'
import { useRecoilState, useRecoilValue } from 'recoil'
import { authenticatedUserAtom } from 'state'
import { ftuxTooltipOpenAtom } from 'state/ftux-tooltip'

function useFtuxTooltip() {
  const user = useRecoilValue(authenticatedUserAtom)
  const [isFtuxTooltipOpen, setIsFtuxTooltipOpen] = useRecoilState(ftuxTooltipOpenAtom)

  const hasShownMyTwinFtuxModal = !!user?.onboarding_steps_completed.includes(OnboardingStep.my_twin_modal_shown)
  const isTwinFtuxTourCompleted = !!user?.onboarding_steps_completed.includes(OnboardingStep.twin_ftux_tour_completed)

  // get the current route
  const isOnMyTwinPage = window.location.pathname.includes('/my-twin')

  // we should only set the tour tooltip as open if the tour is not completed and if the my twin ftux modal has already been shown and the current page is notes
  const shouldOpenFtuxTooltip = !isTwinFtuxTourCompleted && hasShownMyTwinFtuxModal && isOnMyTwinPage

  useEffect(() => {
    if (shouldOpenFtuxTooltip) {
      // we should only set it to be true if the user has not yet completed the tour
      setIsFtuxTooltipOpen(true)
    } else {
      setIsFtuxTooltipOpen(false)
    }
  }, [setIsFtuxTooltipOpen, shouldOpenFtuxTooltip])

  return {
    isTwinFtuxTourCompleted,
    isFtuxTooltipOpen,
    setIsFtuxTooltipOpen,
  }
}

export { useFtuxTooltip }
